import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import KeyFeaturesSection from "./components/KeyFeaturesSection";
import DashboardPreviewSection from "./components/DashboardPreviewSection";
import HowItWorksSection from "./components/HowItWorksSection";
import BenefitsSection from "./components/BenefitsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

export default function HomePage() {
  return (
    <main className="min-h-screen font-inter">
      <Navbar />
      <HeroSection />
      <KeyFeaturesSection />
      <DashboardPreviewSection />
      <HowItWorksSection />
      <BenefitsSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </main>
  );
}
